import {
  createSlice,
  isFulfilled,
  isPending,
  isRejected,
} from '@reduxjs/toolkit';

import {
  updateCourseAsAdminSavingSlice,
  updateCourseSectionAsAdminSavingSlice,
} from './adminApi';
import { RootState } from '../..';

export interface IInitialSavingState {
  status: 'idle' | 'loading' | 'rejected';
}

const initialState: IInitialSavingState = {
  status: 'idle',
};

export const SavingSlice = createSlice({
  name: 'saving',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Matchers
    builder
      .addMatcher(
        isPending(
          updateCourseAsAdminSavingSlice,
          updateCourseSectionAsAdminSavingSlice
        ),
        (state) => {
          state.status = 'loading';
        }
      )
      .addMatcher(
        isFulfilled(
          updateCourseAsAdminSavingSlice,
          updateCourseSectionAsAdminSavingSlice
        ),
        (state) => {
          state.status = 'idle';
        }
      )
      .addMatcher(
        isRejected(
          updateCourseAsAdminSavingSlice,
          updateCourseSectionAsAdminSavingSlice
        ),
        (state) => {
          state.status = 'rejected';
        }
      );
  },
});

export const getSavingState = (state: RootState): RootState['saving'] =>
  state.saving;

export * from './adminApi';
export default SavingSlice.reducer;
